import React, { Component } from 'react';
import {
    BREAKPOINT_SIZES,
    getCurrentBreakpoint
} from 'tradera-utils/breakpoints';

const SplitTest = (ComposedComponent, SplitTest) =>
    class SplitTestHOC extends Component {
        constructor() {
            super();
            this.currentBreakpoint = null;
        }

        getBreakpoint() {
            let { breakpoint } = this.props;

            if (!breakpoint) {
                const current = getCurrentBreakpoint();
                return BREAKPOINT_SIZES[current];
            }
            return breakpoint;
        }

        componentWillMount() {
            this.currentBreakpoint = this.getBreakpoint();
        }

        render() {
            if (!SplitTest || !ComposedComponent) {
                return null;
            } else {
                return (
                    <ComposedComponent
                        {...this.props}
                        currentBreakpoint={this.currentBreakpoint}
                    />
                );
            }
        }
    };

export default SplitTest;
